import { environment } from '../../../../environments/environment';
import { ResponseColumnsPackage } from './view.failedrecords.model';
// control to convert api get data to table
export class ViewFailedRecordsControl {
  /**
   * @arg dataSource the table data to show the received products
   */
  dataSource: Array<object> = [];
  /**
   * @arg apiData the api response for the prodcts to be converted
   */
  apiData: Array<object>;

  /**
   * @method setData sets the data and starts to parse the data
   */
  public setData(data: Array<object>): void {
    this.apiData = data;
    this.ParseData();
  }
  /**
   * @method ParseData parses the data to table data source
   */
  private ParseData(): void {
    this.apiData.forEach(product => {
      this.convertToDataSource(product);
    });
  }
  /**
   * @method convertToDataSource converts each record and makes it linear json
   * @arg product each product record
   */
  private convertToDataSource(product: object): void {
    this.dataSource.push(Object.assign(this.getFixedValues(product)));
  }

  /**
   * @method getFixedValues returns the fixed columns values from the products record
   * @arg product product record
   */
  private getFixedValues(product): object {
    const parsedData = {};
    ResponseColumnsPackage.forEach(key => {
      parsedData[key] = product[key];
    });
    return parsedData;
  }
  /**
   * @method getTableData returns the table data source
   */
  getTableData(): Array<object> {
    return this.dataSource;
  }
  /**
  * @method getColumns returns the column names
  **/
  public getColumns(): Array<string> {
    return [...ResponseColumnsPackage];
  }
}
